// extracted by mini-css-extract-plugin
export var createdDate = "_fr-1";
export var divider = "_fr-2";
export var headerDivider = "_fr-3";
export var messagesCard = "_fr-0";
export var messagesContainer = "_fr-7";
export var messagesContainerWrapper = "_fr-4";
export var pointerCapturingButtonBoxes = "_fr-a";
export var showLeftPanelButton = "_fr-9";
export var showMoreButton = "_fr-c";
export var showMoreButtonContainer = "_fr-b";
export var summaryTitle = "_fr-6";
export var systemMessageCardWrapper = "_fr-d";
export var topButtons = "_fr-8";
export var withPadding = "_fr-5";